module.exports = __webpack_public_path__ + "img/survey-bg.0303950e.jpg";